import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
// Initialise i18n before React mounts. This is what makes a stored Vietnamese
// preference paint on the very first frame instead of flashing English and
// swapping a moment later — `detectInitialLanguage()` runs synchronously and
// `init()` is not async because every resource is bundled.
import "./i18n/i18n";
// The practice loop's keyframes, shared with the other app that
// renders the same loop. See packages/ui/src/styles/practice-loop.css.
import "@lyder-talk/ui/styles/practice-loop.css";
import { auth } from "@lyder-talk/core/lib/auth-client";
import {
  activateSessionHint,
  syncSessionHint,
} from "@lyder-talk/core/lib/session-hint";

// Publish the cross-subdomain "signed in" hint before the first render, so a
// visitor who is signed in and opens the landing page is forwarded straight into
// the app. The app is the only origin that owns a session, so it is the only one
// that writes the hint — see packages/core/src/lib/session-hint.ts.
activateSessionHint();
syncSessionHint(Boolean(auth.getAccessToken()));

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
